import {
    GET_ALL_CAUSES,
    GET_CAUSE_BY_ID,
    CREATE_CAUSE,
    UPDATE_CAUSE_BY_ID,
    DELETE_CAUSE_BY_ID,
    CREATE_LIST_CAUSE,
    CAUSE_ERROR
} from '../action/cause';

const initialState = {
    causes: [],
    cause: null,
    error: null,
};

const causeReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_ALL_CAUSES:
            return {
                ...state,
                causes: payload,
                error: null,
            };
        case GET_CAUSE_BY_ID:
            return {
                ...state,
                cause: payload,
                error: null,
            };
        case CREATE_CAUSE:
            return {
                ...state,
                causes: [...state.causes, payload],
                error: null,
            };
        case CREATE_LIST_CAUSE:
            return {
                ...state,
                causes: [...state.causes, ...payload],
                error: null,
            };
        case UPDATE_CAUSE_BY_ID:
            return {
                ...state,
                causes: state.causes.map(cause =>
                    cause.id === payload.id ? payload : cause
                ),
                error: null,
            };
        case DELETE_CAUSE_BY_ID:
            return {
                ...state,
                causes: state.causes.filter(cause => cause.id !== payload),
                error: null,
            };
        case CAUSE_ERROR:
            return {
                ...state,
                error: payload,
            };
        default:
            return state;
    }
};

export default causeReducer;
